'use client';

import React, { createContext } from 'react';

export const CountryContext = createContext(null);

export const CountryProvider = ({ children, value }) => {
    return (
        <CountryContext.Provider value={value}>
            {children}
        </CountryContext.Provider>
    );
};
